<pg-header
  title="Users"
  ticon="idcard"
  sbtitle="User managmenet"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div class="ds-card grid">
    <app-data-grid
      id="gridContainer"
      style="width: 100%"
      [dataSource]="usrsLst"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="true"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
      exportFileName="LMO Details"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
    >
      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons"
        [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
        [width]="100"
        caption="Edit"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="openSideBar('edit', data)">Edit</div>
        </div></ng-template
      >
      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons"
        [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
        [width]="100"
        caption="Delete"
        cellTemplate="deleteTemplate"
      ></app-grid-column>
      <ng-template appGridCell="deleteTemplate" let-data="cell"
        ><div>
          <div class="tblDelBtn" (click)="openSideBar('delete', data)">
            Delete
          </div>
        </div></ng-template
      >
    </app-data-grid>
  </div>
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    <form nz-form [formGroup]="usrDtlsFrm" autocomplete="off">
      <div nz-row [nzGutter]="16">
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">First Name</div>
          <input type="text" nz-input formControlName="fst_nm" class="br-4" />
        </div>
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">Last Name</div>
          <input type="text" nz-input formControlName="lst_nm" />
        </div>
      </div>
      <div nz-row [nzGutter]="16">
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">Email</div>
          <input type="email" nz-input formControlName="email" class="br-4" />
        </div>
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">Mobile</div>
          <input
            type="number"
            onKeyPress="if(this.value.length==10) return false;"
            nz-input
            formControlName="mobile"
            (keyup)="phnoKeyUp()"
            autocomplete="off"
          />
          @if (ermsg) {
          <span class="nwErMsg">Please Select Valid Phone Number</span>
          }
        </div>
      </div>
      <div nz-row [nzGutter]="16">
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">Select Designation</div>
          <nz-select
            style="width: 100%"
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Designation"
            formControlName="desgn"
          >
            @for (d of dsgnsLst; track d) {
            <nz-option [nzValue]="d.dsgns_id" [nzLabel]="d.dsgns_nm">
            </nz-option>
            }
          </nz-select>
        </div>
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">Select Department</div>
          <nz-select
            style="width: 100%"
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Department"
            formControlName="dprt"
          >
            @for (dp of dprtLst; track dp) {
            <nz-option [nzValue]="dp.dprt_id" [nzLabel]="dp.dprt_nm">
            </nz-option>
            }
          </nz-select>
        </div>
      </div>
      <div nz-row [nzGutter]="16">
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">Select Organisation</div>
          <nz-select
            style="width: 100%"
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Organisation"
            formControlName="orgn"
          >
            @for (o of orgnsLst; track o) {
            <nz-option [nzValue]="o.orgn_id" [nzLabel]="o.orgn_nm"> </nz-option>
            }
          </nz-select>
        </div>
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">Select Role</div>
          <nz-select
            style="width: 100%"
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Role"
            formControlName="role"
          >
            @for (r of rlesLst; track r) {
            <nz-option [nzValue]="r.rle_id" [nzLabel]="r.rle_nm"> </nz-option>
            }
          </nz-select>
        </div>
      </div>
      <input
        type="password"
        name="someName"
        autocomplete="new-password"
        style="display: none"
      />
      <div nz-row [nzGutter]="16">
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">User Name</div>
          <input
            type="text"
            nz-input
            formControlName="usernm"
            class="br-4"
            autocomplete="off"
          />
        </div>
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">Password</div>
          <input
            type="password"
            nz-input
            formControlName="pwd"
            (ngModelChange)="updateConfirmValidator()"
            autocomplete="new-password"
          />
        </div>
      </div>
      @if (invldPwd) {
      <div>
        <span
          >Password must be at least 12 characters and include an uppercase
          letter, a lowercase letter, a number and a special character (and must
          not be a common/weak password).</span
        >
      </div>
      }
      <div nz-row [nzGutter]="16">
        @if (!shwUsrEditDiv) {
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">Confirm Password</div>
          <nz-form-control
            [nzSm]="14"
            [nzXs]="24"
            [nzErrorTip]="errorTpl"
            style="
              min-width: 100%;
              padding-left: 0px !important;
              padding-right: 0px !important;
            "
          >
            <input
              type="password"
              autocomplete="new-password"
              nz-input
              formControlName="cnfrmpwd"
              class="br-4"
            />
            <ng-template #errorTpl let-control>
              @if (control.hasError('confirm')) { Two passwords that you enter
              is inconsistent! }
            </ng-template>
          </nz-form-control>
        </div>
        }
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="6"
          nzLg="6"
          nzXl="24"
          class="usrmegn"
        >
          <div class="inptLbl">Image</div>
          <div class="avatar-upload row">
            <div class="avatar-preview">
              @if (imageUrl != null) {
              <img class="avatar uploadImg" [src]="imageUrl" />
              } @if (imageUrl == null) {
              <img
                class="avatar uploadImg"
                src="assets/images/avatars/profile.jpg"
              />
              }
              <!-- <div id="imagePreview" [style.backgroundImage]="'url('+ imageUrl +')'">
                  </div> -->
            </div>
            <label class="mt-2">
              <input
                (change)="uploadFile($event)"
                type="file"
                id="imageUpload"
                accept=".png, .jpg, .jpeg"
                #fileInput
                style="color: #1b75b6"
                style="display: none"
              />
              <span
                class="btn btn-primary font-size-14 font-weight-600 ml-16 border-radius-3 uploadImgBtn"
              >
                <i
                  nz-icon
                  nzType="camera"
                  nzTheme="fill"
                  class="addBtn-icon-color"
                ></i>
                <!-- <mat-icon _ngcontent-qri-c39=""
                      class="secondary-text s-24 mat-icon notranslate material-icons mat-icon-no-color vertical-align-text-bottom addBtn-icon-color"
                    role="img" aria-hidden="true">add_a_photo</mat-icon> -->
                Upload Image
              </span>
            </label>
          </div>
        </div>
      </div>
      <div nz-row [nzGutter]="16">
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
          <!-- <div class="inptLbl">Is Open on Saturday</div> -->
          <label nz-checkbox formControlName="usr_msg_in" class="inptLbl"
            >Need to send Login Cridentals to user?</label
          >
        </div>
      </div>
      @if (!shwUsrDelDiv) {
      <button
        nz-button
        nzType="primary"
        (click)="saveUserData()"
        class="m-r-10"
      >
        {{ shwUsrEditDiv == true ? "Update" : "Submit" }}
      </button>
      } @if (shwUsrEditDiv==false && shwUsrDelDiv==true) {
      <button
        nz-button
        nzType="primary"
        class="m-r-10"
        nz-popconfirm
        nzPopconfirmTitle="Are you sure delete this user?"
        nzPopconfirmPlacement="bottom"
        [nzIcon]="iconTpl"
        nzOkText="YES"
        nzCancelText="NO"
        (nzOnConfirm)="saveUserData()"
        (nzOnCancel)="cancel()"
      >
        Delete
      </button>
      }
      <ng-template #iconTpl>
        <i nz-icon nzType="question-circle-o" style="color: red"></i>
      </ng-template>
      <button nz-button nzType="primary" (click)="closeSideBar()" nzDanger>
        Cancel
      </button>
    </form>
  </nz-drawer>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
        <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
      </div> -->
  </nz-result>
</div>
}
